import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const LegalMentions = () => {
  return (
    <>
      <Header />
      <section className="container mx-auto px-4 py-6 w-2/3 mt-40">
        <h1 className="text-3xl font-semibold text-gray-800">
          Politique de Confidentialité
        </h1>
        <p className="text-sm text-gray-800 mb-6">dernière MAJ : mars 2026</p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          1. Introduction
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          La présente politique de confidentialité décrit les informations que
          nous recueillons, comment nous les utilisons et les protégeons lorsque
          vous visitez notre site web. En utilisant notre site, vous acceptez
          cette politique.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          2. Collecte d’informations personnelles
        </h2>
        <div>
          {" "}
          <p className="text-gray-600 leading-relaxed mb-4">
            Nous collectons les informations personnelles suivantes via notre
            formulaire de contact :{" "}
          </p>
          <ul className="list-disc pl-5 text-gray-600 mb-4">
            <li>Nom et prénom de l'enfant</li>
            <li>Age de l'enfant ou date du terme</li>

            <li>Nom et prénom du parent 1</li>
            <li>Téléphone du parent 1</li>
            <li>Nom et prénom du parent 2</li>
            <li>Téléphone du parent 2</li>
            <li>Catégorie socio-professionnelle des parents</li>
            <li>Situation des parents</li>
            <li>Numéro de la CAF</li>
            <li>Adresse e-mail</li>
            <li>Adresse</li>
            <li>Numéro de téléphone</li>
            <li>Quotient familial</li>
            <li>Nombre d'enfants au foyer</li>
            <li>Plafond de reveneu</li>
          </ul>
          Nous collectons également des informations relatives à votre
          navigation sur notre site (cookies, adresses IP, etc.) pour améliorer
          votre expérience utilisateur.
        </div>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          3. Utilisation des données personnelles
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Les données que nous collectons sont utilisées pour :</p>
          <ul className="list-disc pl-5 text-gray-600 mb-4">
            <li>Répondre à vos demandes via le formulaire de contact.</li>
            <li>
              Vous fournir des informations ou des services que vous avez
              demandés.
            </li>
            <li>Améliorer notre site web et personnaliser votre expérience.</li>
            <li>Respecter nos obligations légales.</li>
          </ul>
        

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          4. Partage des données personnelles
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Nous ne vendons, n'échangeons ni ne transférons vos informations
          personnelles à des tiers sans votre consentement, sauf si la loi nous
          y oblige (par exemple, en réponse à une demande légale d'une autorité
          compétente).
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          5. Sécurisation des données personnelles
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Nous prenons des mesures de sécurité appropriées pour protéger vos
          données personnelles contre l'accès non autorisé, l'altération, la
          divulgation ou la destruction. Cependant, aucune méthode de
          transmission sur Internet n'est totalement sûre, et nous ne pouvons
          garantir une sécurité absolue.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          6. Droit d’accès, de rectification et de suppression
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Conformément à la législation en vigueur (notamment le RGPD), vous
          disposez d’un droit d’accès, de rectification, de suppression, ainsi
          que de portabilité de vos données personnelles. Vous pouvez exercer
          ces droits en nous contactant à l'adresse suivante :
          microcrecheroanne@gmail.com.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          7. Conservation des données
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Nous conserverons vos données personnelles uniquement pendant la durée
          nécessaire pour répondre à votre demande ou pour respecter nos
          obligations légales et contractuelles.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          8. Cookies
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Ce site utilise des cookies pour améliorer l'expérience utilisateur.
          Vous pouvez gérer vos préférences de cookies via les paramètres de
          votre navigateur.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          9. Modifications de la politique de confidentialité
        </h2>
        <p className="text-gray-600 leading-relaxed mb-4">
          Nous nous réservons le droit de modifier cette politique de
          confidentialité à tout moment. Les modifications seront publiées sur
          cette page avec la date de mise à jour.
        </p>

        <hr className="my-6 border-gray-300" />

        <h2 className="text-2xl font-semibold text-gray-700 mt-4 mb-2">
          Mentions Légales
        </h2>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          1. Informations générales
        </h3>
        <ul className="list-disc pl-5 text-gray-600 mb-4">
          <li>
            <strong>Nom de l'entreprise</strong> : Grain de Malice - SARL
            M.C.C.A.
          </li>
          <li>
            <strong>Forme juridique</strong> : SARL
          </li>
          <li>
            <strong>Capital social</strong> : 10 000 €
          </li>
          <li>
            <strong>Siège social</strong> : 41 Rue Marx Dormoy, 42300 Roanne
          </li>
          <li>
            <strong>Numéro d’immatriculation</strong> : 521 558 387 00028 RCS
            Roanne
          </li>
          <li>
            <strong>Responsable de la publication</strong> : Cécile Berchoux
          </li>
          <li>
            <strong>Contact</strong> : microcrecheroanne@gmail.com & Tél. : 09
            81 65 51 57 ou 06 69 43 55 26
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          2. Hébergement et conception du site
        </h3>
        <ul className="list-disc pl-5 text-gray-600 mb-4">
          <li>
            <strong>Nom de l’hébergeur</strong> : OVH
          </li>
          <li>
            <strong>infos de l’hébergeur</strong> : 2 rue Kellermann – 59100
            Roubaix – France SAS au capital de 10 069 020 € RCS Lille Métropole
            424 761 419 00045 Code APE 2620Z N° TVA : FR 22 424 761 419
          </li>
          <li>
            <strong>Conception</strong> : Com'une impression - Sylvain Matot
            (E.I.) - siren 928844802, Statut : microentreprise.
            <p className="text-gray-600 leading-relaxed mb-4"></p>les photos sont la propriété de Grain de Malice, sauf photo libre de droit :

Repas accueil : Photo de Brooke Lark sur Unsplash, Guitare accueil : Photo de Jefferson Santos sur Unsplash
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          3. Propriété intellectuelle
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Tous les éléments du site web (textes, images, logos, vidéos, etc.)
          sont protégés par des droits de propriété intellectuelle et sont la
          propriété exclusive de Grain de Malice ou de ses partenaires. Toute
          reproduction, diffusion ou utilisation non autorisée des contenus est
          interdite.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          4. Responsabilité
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Nous mettons tout en œuvre pour garantir l'exactitude des informations
          publiées sur notre site, mais nous ne pouvons en garantir
          l’exhaustivité ou l'absence d’erreurs. Nous déclinons toute
          responsabilité en cas de préjudice résultant de l’utilisation de notre
          site ou de l’impossibilité d’y accéder.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          5. Liens externes
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Notre site peut contenir des liens vers des sites externes. Nous ne
          sommes pas responsables du contenu de ces sites et déclinons toute
          responsabilité concernant leur politique de confidentialité.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          6. Données personnelles
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Voir la <strong>politique de confidentialité</strong> ci-dessus.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          7. Loi applicable et juridiction compétente
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Les présentes mentions légales sont régies par la loi [pays où votre
          entreprise est enregistrée]. Tout litige sera soumis à la compétence
          exclusive des tribunaux compétents de [votre ville ou région].
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          8. Rappel infos formulaire et tarifs
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Important : Notre structure se présente sous forme d’une petite SARL,
          elle est donc privée. Nous fonctionnons avec la PAJE micro-crèche. Ce
          type de modalité implique que nous facturons aux parents la globalité
          du coût du mode de garde et que la CAF reverse chaque mois aux parents
          (directement sur leur compte bancaire) une prestation évaluée en
          fonction des revenus annuels des parents. De même, il est important de
          rappeler que dans le cadre d’un contrat avec la micro-crèche, le
          parent n’est pas employeur contrairement à l’emploi d’une assistante
          maternelle. Le parent n’a donc aucune responsabilité particulière
          envers les salariés. La famille paie simplement une prestation de
          service. La CAF applique un plafond de prestation qu’il ne dépasse
          pas. Quoi qu’il en soit (si la facture mensuelle de la crèche est peu
          élevée) les parents garderont à leur charge 15% du montant du mode de
          garde. Une fois inscrit à la CAF, la responsable remplira directement
          (avec l’accord préalable des parents) une télé déclaration par
          internet sur un réseau sécurisé. C’est d’après cette télédéclaration
          que les services de la CAF se basent pour verser les prestations aux
          familles. Les parents n’ont donc aucune démarche à réaliser chaque
          mois. Notre structure applique un tarif variable en fonction des
          revenus des familles. Nous nous basons sur les QF (quotient familial
          de la CAF). Nous utilisons une facturation forfaitaire. Une
          demi-journée est facturée sur une base de 4h30 et une journée de 9h00.
          Tout dépassement, c’est-à-dire toute journée de l’enfant qui
          excéderait 9h sera facturée au même tarif horaire sans supplément. En
          cas de litige, il est possible de faire appel à un médiateur à la
          consommation :Mme Laurence PRUD’HOMME / Tél : 06.12.95.62.18./ mail :
          laurence.prudhomme@free.fr
        </p>
        <p className="text-gray-600 leading-relaxed mb-4">
          Les informations recueillies sur ce site sont enregistrées dans un
          fichier informatisé par la Micro-crèche Grain de Malice pour
          pré-inscription. La base légale du traitement sont les intérêts
          légitimes des deux parties pour la préinscription. Les données
          collectées seront communiquées aux seuls destinataires suivants :
          émetteur du formulaire et la micro-crèche Grain de Malice. Les données
          sont conservées pendant le temps de l’inscription et pour une durée de
          36 mois maximum selon le RGPD. Vous pouvez accéder aux données vous
          concernant, les rectifier, demander leur effacement ou exercer votre
          droit à la limitation du traitement de vos données. (en fonction de la
          base légale du traitement, mentionner également : Vous pouvez retirer
          à tout moment votre consentement au traitement de vos données ; Vous
          pouvez également vous opposer au traitement de vos données ; Vous
          pouvez également exercer votre droit à la portabilité de vos données)
          Consultez le site cnil.fr pour plus d’informations sur vos droits.
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez contacter La Micro-Crèche
          : 41 Rue Marx Dormoy, 42300 Roanne - Tél. : 09 81 65 51 57 ou 06 69 43
          55 26 - microcrecheroanne@gmail.com Si vous estimez, après nous avoir
          contactés, que vos droits « Informatique et Libertés » ne sont pas
          respectés, vous pouvez adresser une réclamation à la CNIL.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mt-4 mb-2">
          9. Contact
        </h3>
        <p className="text-gray-600 leading-relaxed mb-4">
          Pour toute question concernant les mentions légales, vous pouvez nous
          contacter à l’adresse suivante : microcrecheroanne@gmail.com.
        </p>
      </section>
      <Footer />
    </>
  );
};

export default LegalMentions;
